import React from 'react';
import PropTypes from 'prop-types';

const WidgetTypePicker = ({ options, onSelect }) => (
  <div className="widget-type-picker mx-auto">
    <h4 className="widget-type-picker__heading">Select Tile Type</h4>
    <select
      className="form-control"
      defaultValue=""
      onChange={(e) => e.target.value && onSelect(e.target.value)}
    >
      <option value="" disabled>Select Type</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

WidgetTypePicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default WidgetTypePicker;
